{
  "name": "@jspsych-multiplayer/plugin-multiplayer-role",
  "version": "0.1.0",
  "description": "jsPsych plugin: assign multiplayer group roles by deterministic consensus",
  "type": "module",
  "main": "dist/index.cjs",
  "exports": {
    "import": "./dist/index.js",
    "require": "./dist/index.cjs"
  },
  "typings": "dist/index.d.ts",
  "unpkg": "dist/index.browser.min.js",
  "files": [
    "src",
    "dist"
  ],
  "source": "src/index.ts",
  "scripts": {
    "test": "jest",
    "test:watch": "npm test -- --watch",
    "tsc": "tsc",
    "build": "rollup --config",
    "build:watch": "npm run build -- --watch"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/jspsych/jspsych-multiplayer.git",
    "directory": "packages/plugin-multiplayer-role"
  },
  "keywords": [
    "jsPsych"
  ],
  "author": {
    "name": "Hannah Tsukamoto",
    "url": "https://github.com/htsukamoto5"
  },
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/jspsych/jspsych-multiplayer/issues"
  },
  "homepage": "https://github.com/jspsych/jspsych-multiplayer/blob/main/packages/plugin-multiplayer-role/README.md",
  "peerDependencies": {
    "jspsych": ">=8.0.0"
  },
  "devDependencies": {
    "jspsych": "^8.0.0",
    "@jspsych/config": "^3.2.2",
    "@jspsych/test-utils": "^1.0.0"
  }
}
